"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _styles = require("./styles");
var _excluded = ["title", "subtitle", "text", "description", "children", "colorType", "monochrome", "minHeight", "sideLine", "sideLineColor"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Box = function Box(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    text = _ref.text,
    description = _ref.description,
    children = _ref.children,
    colorType = _ref.colorType,
    monochrome = _ref.monochrome,
    minHeight = _ref.minHeight,
    _ref$sideLine = _ref.sideLine,
    sideLine = _ref$sideLine === void 0 ? true : _ref$sideLine,
    sideLineColor = _ref.sideLineColor,
    rest = _objectWithoutProperties(_ref, _excluded);
  var textStyleProps = (0, _lodash.pick)(rest, ['fontWeight', 'color']);
  return /*#__PURE__*/_react["default"].createElement(_styles.Wrapper, _extends({
    colorType: colorType,
    monochrome: monochrome
  }, rest), sideLine && /*#__PURE__*/_react["default"].createElement(_styles.Border, {
    colorType: colorType,
    monochrome: monochrome,
    minHeight: minHeight,
    borderColor: sideLineColor
  }), /*#__PURE__*/_react["default"].createElement(_styles.Content, {
    sideLine: sideLine
  }, title && /*#__PURE__*/_react["default"].createElement(_styles.Title, _extends({
    colorType: colorType,
    monochrome: monochrome
  }, textStyleProps), title), subtitle && /*#__PURE__*/_react["default"].createElement(_styles.Subtitle, _extends({
    colorType: colorType,
    monochrome: monochrome
  }, textStyleProps), subtitle), text && /*#__PURE__*/_react["default"].createElement(_styles.Text, _extends({
    colorType: colorType,
    monochrome: monochrome
  }, textStyleProps), text), description && /*#__PURE__*/_react["default"].createElement(_styles.Description, _extends({
    colorType: colorType,
    monochrome: monochrome
  }, textStyleProps), description), children));
};
Box.propTypes = {
  title: _propTypes["default"].node,
  subtitle: _propTypes["default"].node,
  text: _propTypes["default"].node,
  description: _propTypes["default"].node,
  children: _propTypes["default"].node,
  minHeight: _propTypes["default"].string,
  colorType: _propTypes["default"].string,
  monochrome: _propTypes["default"].bool,
  sideLine: _propTypes["default"].bool,
  sideLineColor: _propTypes["default"].string
};
var _default = exports["default"] = Box;